// extracted by mini-css-extract-plugin
export default {"tableAppInfoLogo":"+metL1t8JBH-viMLx8i6+w==","tableSep":"jEkVDujrhFrK1OXc6RaGOw==","progressIcon":"_666J8SmVYgiszu4ua6CNAA=="};